<template>
    <b-row class="row justify-content-center">
        <SolutionCard name="prosta_parkirisca"></SolutionCard>
        <SolutionCard name="domaca_oskrba"></SolutionCard>
        <SolutionCard name="sentimeter"></SolutionCard>
        <SolutionCard name="avtolog"></SolutionCard>
        <SolutionCard name="strava"></SolutionCard>
        <SolutionCard name="cestni_asistent"></SolutionCard>
        <SolutionCard name="eko_izletnik"></SolutionCard>
        <SolutionCard name="organizator_dogodkov"></SolutionCard>
        <SolutionCard name="interaktivno_mesto"></SolutionCard>
        <SolutionCard name="gospodarski_trendi"></SolutionCard>
        <SolutionCard name="nijz_priporocila"></SolutionCard>
        <SolutionCardEmpty title="Dodaj svojo rešitev"></SolutionCardEmpty>
    </b-row>
</template>

<script>
    import SolutionCard from "../solution/SolutionCard";
    import SolutionCardEmpty from "../solution/SolutionCardEmpty";


    export default {
        name: "PmisSearchResultContainer",
        components: {
            SolutionCard, SolutionCardEmpty
        }
    }
</script>

<style scoped>
</style>
